"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _locale = require("../locale");

var _locale2 = _interopRequireDefault(_locale);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ControlSubmit = function ControlSubmit(props) {
  return _react2.default.createElement("button", {
    className: "btn",
    type: "submit",
    disabled: !props.isValid
  }, props.isSubmit ? _locale2.default.getResource("otb_ControlSubmit") : _locale2.default.getResource("otb_ControlNext"));
};

ControlSubmit.propTypes = {
  isValid: _propTypes2.default.bool.isRequired,
  isSubmit: _propTypes2.default.bool
};
exports.default = ControlSubmit;